import { BiCollapseAlt } from 'react-icons/bi';
import './AccessUnitSelector.css';
import { useUserStore } from '../../contexts/userStore';
import ModalComponent from '../Modal/ModalComponent';
import { UnitsTreeView } from '../UnitsTreeView/UnitsTreeView';
import { useEffect, useState } from 'react';
import Select from '../Select/Select';
import { useTranslation } from 'react-i18next';

export const AccessUnit = {
   Outdoor: 'Outdoor',
   Indoor: 'Indoor',
   Dynamic: 'Dynamic',
}

export const AccessUnitOptions = {
   Unidade: "common.unit",
   [AccessUnit.Outdoor]: "common.externalArea",
   [AccessUnit.Indoor]: "common.internalArea",
   [AccessUnit.Dynamic]: "common.dynamicArea",
}

export function AccessUnitSelector({ unitId, setUnitId, label, scopedUnitId, ...props }) {
   const { condominiums } = useUserStore();
   const [modalIsOpen, setModalIsOpen] = useState(false);
   const [modalState, setModalState] = useState({ unitId });
   const [mode, setMode] = useState(Object.values(AccessUnit).includes(unitId) ? unitId : 'Unidade');
   const { t } = useTranslation();

   useEffect(() => {
      setModalState({ unitId });
      setMode(Object.values(AccessUnit).includes(unitId) ? unitId : 'Unidade');
   }, [unitId]);

   return (
      <>
         <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label htmlFor="select-unit-button" style={{ fontSize: '14px', textAlign: 'left', color: 'var(--textColor)', marginBottom: 5 }}>
               {label ?? 'Pertence a'}
            </label>
            <button type='button' id="select-unit-button" className='btn-select-unit' onClick={e => setModalIsOpen(true)}>
               <span>
                  {(Object.values(AccessUnit).includes(unitId) ? t(AccessUnitOptions[unitId]) : condominiums.find(unit => unit.id === `${unitId}`)?.name) ?? <small>Selecione</small>}
               </span>
               <BiCollapseAlt />
            </button>
         </div>
         {
            modalIsOpen && (
               <ModalComponent
                  modalIsOpen={modalIsOpen}
                  modalText={`Sentido ${label}`}
                  handleConfirm={() => {
                     setUnitId(mode === 'Unidade' ? modalState.unitId : mode);
                     setModalIsOpen(false);
                  }}
                  handleCancel={() => { setModalIsOpen(false); }}
                  hideButtons={false}
               >
                  <div className="modal-levels-selector-content">
                     <Select
                        value={mode}
                        onChange={({ target }) => {
                           setMode(target.value)
                        }}
                        disabled={props.formMode === "consulta"}
                        required={false}
                        options={[
                           { value: 'Unidade', text: t(AccessUnitOptions.Unidade) },
                           { value: AccessUnit.Outdoor, text: t(AccessUnitOptions[AccessUnit.Outdoor]) },
                           { value: AccessUnit.Indoor, text: t(AccessUnitOptions[AccessUnit.Indoor]) },
                           { value: AccessUnit.Dynamic, text: t(AccessUnitOptions[AccessUnit.Dynamic]) },
                        ]}
                     />
                     {mode === 'Unidade' && (
                        <div style={{ marginTop: '15px' }}>
                           <UnitsTreeView
                              showRoot={false}
                              scopedUnitId={scopedUnitId}
                              values={modalState.unitId ? [modalState.unitId] : []}
                              onChange={ids => {
                                 setModalState(prev => ({ unitId: ids[0] }))
                              }}
                              singleCheck={true}
                           />
                        </div>
                     )}
                  </div>
               </ModalComponent>
            )
         }
      </>
   );
}